import React from 'react';
import { FormModal } from 'components/common';
import { Col, Form, Row, Select } from 'components';
import { AssignmentRoleMapping } from 'models/Lead';
import { useAssignmentEdit } from './useAssignmentEdit';
import { AdminsSelect } from 'components/common/adminsSelect';

export interface IAssignmentUpdate {
  onCancel: () => void;
  open: boolean;
}

export const AssignmentEditModal = React.memo((props: IAssignmentUpdate) => {
  const { onCancel: onCancelModal, open } = props;
  const { onFinish, userData, form, isLoading, onCancel } = useAssignmentEdit({
    onCancelModal,
    open,
  });

  return (
    <FormModal
      form={form}
      title={'Update Assignments'}
      okText={'Save'}
      open={open}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Form.Item label={AssignmentRoleMapping.administrator} name={'administratorId'}>
            <AdminsSelect size={'large'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={AssignmentRoleMapping.salesManager} name={'salesManagerId'}>
            <AdminsSelect size={'large'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.salesManagerId !== currentValues.salesManagerId
            }
          >
            {({ getFieldValue, setFieldValue }) => {
              const salesManagerId = getFieldValue('salesManagerId');
              const salesManagerAssistantId = getFieldValue('salesManagerAssistantId');
              if (salesManagerId === salesManagerAssistantId) setFieldValue('salesManagerAssistantId', '');
              return (
                <Form.Item label={AssignmentRoleMapping.salesManagerAssistant} name={'salesManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('salesManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('salesManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={AssignmentRoleMapping.purchaseManager} name={'purchaseManagerId'}>
            <AdminsSelect size={'large'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.purchaseManagerId !== currentValues.purchaseManagerId
            }
          >
            {({ getFieldValue, setFieldValue }) => {
              const purchaseManagerId = getFieldValue('purchaseManagerId');
              const purchaseManagerAssistantId = getFieldValue('purchaseManagerAssistantId');
              if (purchaseManagerId === purchaseManagerAssistantId) setFieldValue('purchaseManagerAssistantId', '');
              return (
                <Form.Item label={AssignmentRoleMapping.purchaseManagerAssistant} name={'purchaseManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('purchaseManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('purchaseManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
});
